import { EnumIdvMethod } from '@wallet-manager/pfh-pmp-node-def-types/dist/src/DbModel/Master';
import { SingleSelection } from '../../../../components';
import { useTranslation } from '../../../../hooks';

interface IProps {
  label?: string;
  value: any;
  onChange: (e: any) => void;
  onClear: () => void;
}

const IdvMethodSingleSelection = (props: IProps) => {
  const { label, value, onChange, onClear } = props;

  const { tc, t } = useTranslation('EnumIdvMethod');

  return (
    <SingleSelection
      label={label || tc('phSelection', { fieldName: tc('idvMethod') })}
      value={value || ''}
      onChange={onChange}
      clearSelect={onClear}
      enumData={EnumIdvMethod}
      nameFn={(item) => t(item)}
    />
  );
};

export default IdvMethodSingleSelection;
